var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 327.64 31.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ed1e79;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u05E4\\u05E2\\u05D9\\u05DC\\u05D5\\u05EA_\\u05E6\\u05D9\\u05D1\\u05D5\\u05E8\\u05D9\\u05EA",
    "data-name": "\\u05E4\\u05E2\\u05D9\\u05DC\\u05D5\\u05EA \\u05E6\\u05D9\\u05D1\\u05D5\\u05E8\\u05D9\\u05EA"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.36,21.54h-2.81v4H0v-10.4h9.36V3.33h7.25v22.2h-7.25v-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.05,19.13V3.33h7.22l.04,22.2h-12.95v-6.4h5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.67,3.33h7.25v12.21h-7.25V3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.53,25.53h-19.57v-6.4h9.14v-9.4h-9.14V3.33h16.39v15.8h3.18v6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.85,3.33h7.25v22.2h-7.25V3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.77,0h7.25v3.33h12.43l-9.58,22.94-6.62-2.7,5.85-13.84h-9.33V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.3,3.33h7.25v22.2h-7.25V3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140.93,9.73h-14.02V3.33h21.28v22.2h-7.25v-15.8ZM127.17,13.8h7.25v11.73h-7.25v-11.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175.68,3.33l-8.18,22.68-6.73-2.63,4.96-13.65h-13.21V3.33h23.16ZM152.51,13.43h7.25v17.65h-7.25V13.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178.34,3.33h7.25v12.21h-7.25V3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.9,3.33l-8.18,22.68-6.73-2.63,4.96-13.65h-13.21V3.33h23.16ZM189.74,13.43h7.25v17.65h-7.25V13.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.32,12.69v12.88h-7.25v-12.73c0-2-1.52-3.59-3.48-3.59s-3.48,1.59-3.48,3.59v12.69h-7.25v-12.84c0-6.11,4.85-10.1,10.73-10.1s10.73,4.03,10.73,10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.53,3.33h7.25v12.21h-7.25V3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M261.15,3.33h7.25v22.2h-7.25V3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M277.83,19.13V3.33h7.22l.04,22.2h-12.95v-6.4h5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.45,3.33h7.25v12.21h-7.25V3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M327.64,3.33v10.84c0,7.62-4.92,12.1-13.36,12.1s-13.36-4.48-13.36-12.1V3.33h7.14v5.51h2.81V3.33h6.81v11.73h-9.58c.37,2.96,2.59,4.55,6.18,4.55,3.92,0,6.22-1.92,6.22-5.44V3.33h7.14Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdpi);
export default __webpack_public_path__ + "static/media/שינוי חקיקה ולובינגmdpi.e2724b54fa9a72bf826e8048affbeb3c.svg";
export { ForwardRef as ReactComponent };